"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsProd = exports.checkIsNotProd = void 0;
var getGlobalWindow_1 = require("./getGlobalWindow");
var checkIsNotProd = function () {
    // @ts-ignore
    var envs = (process === null || process === void 0 ? void 0 : process.env) || {};
    var initIsNotProd = (envs === null || envs === void 0 ? void 0 : envs.REACT_APP_ENV) === "dev" || // 天空之城预发
        (envs === null || envs === void 0 ? void 0 : envs.REACT_APP_ENV_COMPONENTS) === "true" || // 天空之城组件
        (envs === null || envs === void 0 ? void 0 : envs.MODE) === "test" || // react 项目
        (envs === null || envs === void 0 ? void 0 : envs.NODE_ENV) === "beta"; // im 项目
    return initIsNotProd;
};
exports.checkIsNotProd = checkIsNotProd;
var checkIsProd = function () {
    var wd = (0, getGlobalWindow_1.getWindow)();
    var _isProd = (wd === null || wd === void 0 ? void 0 : wd.checkIsPro) ? wd === null || wd === void 0 ? void 0 : wd.checkIsPro() : !(0, exports.checkIsNotProd)();
    return _isProd;
};
exports.checkIsProd = checkIsProd;
